<div class="container-fluid">
  <div id="header">
    <nav class="pb-4 row bg-brand-header">
      <span class="offset-sm-1 offset-md-0 col-sm-2 mt-3">
        <img class="img-fluid" [src]="logoUrl" alt="gaalon">
      </span>
      <div class="w-100 d-md-none d-lg-none d-xl-none d-xxl-none"></div>
      <h1 class="offset-1 col-sm-8 text-responsive" style="color: white">
        {{headerTitle}}
      </h1>
    </nav>
  </div>
  <div class="pl-5 pr-5" id="content">
    <router-outlet></router-outlet>
  </div>
</div>
